<template>
  <div class="common">
    <a-tabs type="card" v-model="tabCur">
      <a-tab-pane v-for="item in tabData" :key="item.key" :tab="item.name">
        <keep-alive v-if="tabCur == item.key">
          <component :is="item.comp" :tabType="item.key" :gldStCds="item.gldStCds"
            :goldStatusOptions="item.goldStatusOptions" :rcPty="item.rcPty" :pypts="item.pypts"
            :isGldPay="item.isGldPay" :isGldLend="item.isGldLend" :pypt="item.pypt" :isGldEx="item.isGldEx"
            :exDayEnd="item.exDayEnd" :exDayStart="item.exDayStart" formType="seller" :totalName="item.totalName"
            :totalProp="item.totalProp" :columnsSource="item.columns" :gldBal="item.gldBal"
            :toBeGldPaid="item.toBeGldPaid" :formSource="item.form" :fromTypeRouter="item.fromType"
            fromPath="circulation/goldpay" :selectName="item.selectName" :selectProp="item.selectProp"></component>
        </keep-alive>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import goldPage from "@/components/gold-page/gold-page"
const systemDate = window.sessionStorage.getItem('systemDate') || new Date();
export default {
  components: {
    goldPage
  },
  name: "goldpay",
  data() {
    return {
      tabData: [
        {
          name: "祺信流转",
          key: "goldpay",
          comp: goldPage,
          fromType: "5",
          gldStCds: "1",
          exDayStart: this.utils.dateFormat(new Date(systemDate), 'yyyy-MM-dd', null, 2),
          rcPty: this.$store.getters['home/getUserObj'].cstIds.join(','),
          totalName: "祺信余额",
          totalProp: "gldBal",
          selectName: "支付金额",
          selectProp: "payAmt",
          gldBal: "0",
          toBeGldPaid: "1",
          columns: ["祺信编号", "开立方", "担保方", "祺信余额(元)", "支付金额(元)", "到期日期", "剩余天数", "变更状态", "有无发票", "转让协议"],
          form: ["祺信编号", "开立方", "到期日期", "变更状态"]
        },
        {
          name: "待复核",
          fromType: "1",
          key: "goldpayPendingReview",
          comp: goldPage,
          gldStCds: "7",
          isGldPay: 'Y',
          pypts: this.$store.getters['home/getUserObj'].cstIds.join(','),
          columns: ["支付日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "到期日期", "变更状态", "有无发票", "操作"],
          form: ["支付日期", "祺信编号", "接收方", "到期日期", "变更状态", "开立方"]
        },
        {
          name: "待签收",
          fromType: "1",
          key: "goldpayPendingReceipt",
          comp: goldPage,
          gldStCds: "0",
          pypts: this.$store.getters['home/getUserObj'].cstIds.join(','),
          isGldPay: "Y",
          columns: ["支付日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "到期日期", "变更状态", "有无发票", "操作"],
          form: ["支付日期", "祺信编号", "接收方", "到期日期", "变更状态", "开立方"]
        },
        {
          name: "已签收",
          fromType: "1",
          key: "goldpaySigned",
          comp: goldPage,
          gldStCds: "1",
          pypts: this.$store.getters['home/getUserObj'].cstIds.join(','),
          isGldPay: 'Y',
          columns: ["到期日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "待收余额(元)", "回款金额(元)", "变更状态", "是否逾期", "有无发票", "操作"],
          form: ["支付日期", "祺信编号", "接收方", "到期日期", "变更状态", "开立方"]
        },
        {
          name: "全部",
          key: "goldpayAll",
          fromType: "1",
          comp: goldPage,
          gldStCds: "0,1,2,3,6,7,8",
          pypts: this.$store.getters['home/getUserObj'].cstIds.join(','),
          isGldPay: 'Y',
          goldStatusOptions: [
            { value: '0', name: '待签收' },
            { value: '1', name: '已签收' },
            { value: '2', name: '已撤销' },
            { value: '3', name: '已拒绝' },
            { value: '4', name: '确认已拒绝' },
            { value: '5', name: '待确认' },
            { value: '6', name: '已结清' },
            { value: '7', name: '待复核' },
            { value: '8', name: '复核已拒绝' }
          ],
          columns: ["支付日期", "祺信编号", "开立方", "担保方", "接收方", "祺信面额(元)", "到期日期", "变更状态", "祺信状态", "有无发票", "操作"],
          form: ["支付日期", "祺信编号", "接收方", "到期日期", "变更状态", "祺信状态", "开立方"]
        }
      ],
      tabCur: "goldpay"
    }
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj"

    })
  },
  created() {
  },
  mounted() {

  },
  methods: {


  },
  activated() {

  },
};
</script>
<style scoped lang="less">
.common {
  /deep/ .ant-tabs-tab-active {
    border-bottom: 1px solid #e8e8e8 !important;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/goldpay.vue